import { unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { html } from "lit/static-html.js";
import { SlotController } from "@/common/controllers/slot";
import { when } from "@/common/directives/when";
import { EkoElement } from "@/utilities/element";
import style from "./divider.css?inline";

export type DividerVariant = "single-line" | "dual-line" | "background" | "form";

@customElement("eko-divider")
class Divider extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private defaultSlot = new SlotController(this);

  @property({ reflect: true }) variant: DividerVariant = "single-line";

  render() {
    // Form variant has a different layout
    if (this.variant === "form") {
      return html`
        <div class="eko-divider__content-wrapper" part="content-wrapper">
          <slot></slot>
          <slot name="before"></slot>
        </div>
        <div class="eko-divider__divider" part="divider"></div>
        <slot name="after"></slot>
      `;
    }

    // Dual line and Background variants have content in the center
    if (this.variant === "dual-line" || this.variant === "background") {
      return html`
        <div class="eko-divider__content" part="content">
          <slot></slot>
        </div>
      `;
    }

    // Default/single-line variant has dividers on both sides
    return html`
      <div class="eko-divider__divider" part="divider"></div>
      <slot
        part=${when(this.defaultSlot.isPresent, "content")}
        class=${when(this.defaultSlot.isPresent, "eko-divider__content", "hidden")}></slot>
      <div
        class=${when(this.defaultSlot.isPresent, "eko-divider__divider", "hidden")}
        part=${when(this.defaultSlot.isPresent, "divider")}></div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-divider": Divider;
  }
}

export default Divider;
